import React, { useState } from 'react';
import { Button } from '@mui/material';
import { kakaoLogin } from '../utils/kakao';
import { apiClient } from '../config/api';

interface KakaoLoginButtonProps {
  onError?: (error: string) => void;
  disabled?: boolean;
  variant?: 'contained' | 'outlined';
  fullWidth?: boolean;
  sx?: any;
  children?: React.ReactNode;
}

const KakaoLoginButton: React.FC<KakaoLoginButtonProps> = ({
  onError,
  disabled = false,
  variant = 'outlined',
  fullWidth = false,
  sx = {},
  children = '카카오로 시작하기'
}) => {
  const [loading, setLoading] = useState(false);

  const handleKakaoLogin = async () => {
    setLoading(true);
    
    try {
      // 모든 기존 인증 정보 정리 (새 로그인 시작)
      apiClient.clearAuthData();
      
      // 카카오 로그인 페이지로 리다이렉트
      await kakaoLogin();
    } catch (error: any) {
      onError?.(error.message);
    } finally {
      setLoading(false);
    }
  };

  const defaultSx = {
    py: 1.5,
    backgroundColor: '#FEE500',
    color: '#000',
    border: '1px solid #FEE500',
    '&:hover': {
      backgroundColor: '#FDD835',
      border: '1px solid #FDD835',
    },
    '&:disabled': {
      backgroundColor: '#F5F5F5',
      color: '#BDBDBD',
    },
    ...sx
  };

  return (
    <Button
      variant={variant}
      fullWidth={fullWidth}
      onClick={handleKakaoLogin}
      disabled={disabled || loading}
      sx={defaultSx}
    >
      {loading ? '연결 중...' : children}
    </Button>
  );
};

export default KakaoLoginButton;